import { useContext } from 'react'
import { BulkActionContext } from './context'

export const useBulkActionContext = () => {
  const context = useContext(BulkActionContext)

  if (context === undefined)
    throw new Error('Must be used within BulkActionContextProvider')

  return context
}
